module.exports = __webpack_public_path__ + "assets/img/budapark6-320.9b803bf8.webp";